import Repository from '@/libs/axios'

const filterSaveResource = '/admin/saved-filters'

export default {
  saveFilter(payload) {
    return Repository.post(`${filterSaveResource}/store`, payload)
  },
  getFilterNames(model) {
    return Repository.get(`${filterSaveResource}/filter-names?model=${model}`)
  },
  getFilterDataById(id, model) {
    return Repository.get(
      `${filterSaveResource}/filter-data/${id}?model=${model}`,
    )
  },
  deleteFilter(id, model) {
    return Repository.delete(
      `${filterSaveResource}/delete/${id}?model=${model}`,
    )
  },
}
